export default "ui-option-basic{justify-content:space-between}\n";